/**
 * Resolves the sidebar Overview shortcut's title from the org's optional
 * custom-label override (IOrganisationTypeResp.customOverviewLabel).
 * Extracted so the fallback logic — the part most likely to regress into a
 * blank/whitespace shortcut label — is testable without MenuService's
 * dependency graph.
 *
 * Default (unset/blank) resolves to the i18n KEY 'menu.OVERVIEW', not the
 * English word — the caller passes this through the `translate` pipe, so
 * every org that hasn't customized this keeps normal per-locale
 * translation. Once an org sets a real value, that literal string is
 * returned as-is and passes through `translate` unchanged (no matching
 * key), same behaviour as the existing customTaskName/customClientName/
 * customProjectName fields.
 */
const DEFAULT_OVERVIEW_KEY = 'menu.OVERVIEW';

export function resolveOverviewLabel(customLabel: string | null | undefined): string {
  const trimmed = (customLabel || '').trim();
  return trimmed || DEFAULT_OVERVIEW_KEY;
}
